<template>
  <div class="carousel-menu-wrap">
    <menu-title :close="close">绑定角色</menu-title>
    <menu-item class="menu-item-switch" label="描述背景图">
      <div class="custom-back-img">
        <menu-background-image class="mt-2" image-opacity-key image-key="helperImage" eye-key="helperImageShow"
          :target="model" />
      </div>
    </menu-item>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import menuTitle from '~/components/menu/menuTitle';
import MenuItem from '~/components/menu/menuItem';
import menuBackgroundImage from "~/components/menu/menuBackgroundImage";

export default {
  name: 'EditMenuCollapse',
  components: {
    MenuItem,
    menuBackgroundImage,
    menuTitle,
  },
  props: {
    model: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  methods: {
    ...mapMutations({
      'ADD_MENU_KEY': 'menu/ADD_MENU_KEY',
      'REMOVE_MENU_KEY': 'menu/REMOVE_MENU_KEY'
    }),
    close() {
      this.REMOVE_MENU_KEY('bind-user')
      this.$nextTick(() => {
        this.SiteMenu.close('bind-user')
      })
    },
  }
}
</script>
